import styles from './PaymentOptionItem.module.scss';

import { TextV2, TextV2Variant } from 'components/TextV2/TextV2';
import React from 'react';

interface IPaymentOptionItemProps {
  item?: string;
  variantType?: TextV2Variant;
}

export const PaymentOptionItem: React.FC<IPaymentOptionItemProps> = ({
  item,
  variantType = 'body-small',
}) => {
  if (!item) return null;

  return (
    <div className={styles.item} role="list-item">
      <TextV2 value={item} tagName="p" variant={variantType} className={styles.itemText} />
    </div>
  );
};
